// Description: Console log for Damselfly Creative
import figlet from "figlet";
import standard from "figlet/importable-fonts/Standard.js";
figlet.parseFont("Standard", standard);
figlet.text("Damselfly\nCreative", function (err, data){
 console.log(data, '\nSITE BY: https://damselflycreative.com')
});
